import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import css from './LoadingDots.module.scss';

const LOADING_DOTS = ['', '.', '..', '...'] as const;

export const LoadingDots = () => {
  const [loadingDots, setLoadingDots] = useState<(typeof LOADING_DOTS)[number]>(
    LOADING_DOTS[0]
  );
  const loadingDotsIndexRef = useRef(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      loadingDotsIndexRef.current =
        (loadingDotsIndexRef.current + 1) % LOADING_DOTS.length;
      setLoadingDots(LOADING_DOTS[loadingDotsIndexRef.current]);
    }, 500);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return <span className={css.loadingDots}>{loadingDots}</span>;
};
